import Vue from 'vue'
import patients from '../../api/patients'

// initial state
const state = {
  patients: {root: [], totalCount: 0},
  patient: {root: [], totalCount: 0},
  savePatientResponse: false,
  deletePatientResponse: false
}

// getters
const getters = {
  patients: state => state.patients,
  patient: state => state.patient,
  savePatientResponse: state => state.savePatientResponse,
  deletePatientResponse: state => state.deletePatientResponse
}

// actions
const actions = {
  getPatients: function (context, data) {
    patients.getPatients(data, patients => {
      context.commit('RECEIVE_PATIENTS', { patients })
    })
  },
  getPatient: function (context, data) {
    patients.getPatient(data, patient => {
      context.commit('RECEIVE_PATIENT', { patient })
    })
  },
  savePatient: function (context, data) {
    patients.savePatient(data, savePatientResponse => {
      context.commit('SAVE_RESPONSE', { savePatientResponse })
    })
  },
  deletePatient: function (context, data) {
    patients.deletePatient(data, deletePatientResponse => {
      context.commit('DELETE_RESPONSE', { deletePatientResponse })
    })
  }
}

// mutations
const mutations = {
  ['RECEIVE_PATIENTS'] (state, { patients }) {
    patients.totalCount = parseInt(patients.totalCount)
    state.patients = patients
  },
  ['RECEIVE_PATIENT'] (state, { patient }) {
    patient.totalCount = parseInt(patient.totalCount)
    state.patient = patient
  },
  ['SAVE_RESPONSE'] (state, { savePatientResponse }) {
    state.savePatientResponse = savePatientResponse
  },
  ['DELETE_RESPONSE'] (state, { deletePatientResponse }) {
    if(deletePatientResponse.error == true) Vue.$notify.error(deletePatientResponse.notice);
    else Vue.$notify.success(deletePatientResponse.notice);
    state.deletePatientResponse = deletePatientResponse
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/patients.js